// Copyright © 2024 Move Closer

import { Component } from 'vue-property-decorator'

import { ModuleAdditionalRows } from '../../_contracts'

import { TeaserBoxVersion } from '../TeaserBox.contracts'
import { GridConfigType, TeaserBoxAddonsMixin } from '../TeaserBox.shared'
import { ListType, TileSize, TileSizeMobile } from '../../_components/Tile'

/**
 * Two-column layout with proper addon support:
 * - Left column (3/4): Uses ThumbnailsListWithAddons for tiles with addons
 * - Right column (1/4): Uses TextListWithAddons for text list with addons
 * This maintains the original design while ensuring consistent addon handling.
 */
@Component({
  name: 'TeaserBoxInnerGridL4STextListTabs'
})
export class TeaserBoxInnerGridL4STextListTabs extends TeaserBoxAddonsMixin {
  public static readonly moduleVersion: TeaserBoxVersion = TeaserBoxVersion['L-4S-text-list-tabs']

  public gridConfig: GridConfigType = {
    defaultSize: TileSize.S,
    mobileSize: TileSizeMobile.TILE_PLUS_TEXT,
    tiles: {
      0: TileSize.L
    },
    listOffset: 5,
    listType: ListType.LIST
  }

  public get tilesOffset (): number {
    switch (this.teaserBoxConfig.additionalRows) {
      case ModuleAdditionalRows.addOne:
        return this.gridConfig.listOffset + 3
      case ModuleAdditionalRows.addTwo:
        return this.gridConfig.listOffset + 6
      default:
        return this.gridConfig.listOffset
    }
  }
}
